import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';
import Icon from '@component/icon';

const NotSupported = ({ extension }) => {
  const title = I18n.t('transfer.preview.unsupported_title', { extension });
  const copy = I18n.t('transfer.preview.unsupported_copy');

  return (
    <div className="not-supported">
      <span className="not-supported__container">
        <Icon className="not-supported__icon" type="Fallback" />
      </span>
      <h3 className="not-supported__title">{title}</h3>
      <p
        className="not-supported__meta"
        dangerouslySetInnerHTML={{ __html: copy }}
      />
    </div>
  );
};

NotSupported.propTypes = {
  extension: PropTypes.string,
};

export default NotSupported;
